var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoalTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.666993 17L0.666992 1.88889M0.666992 9.88889H7.19625C7.69041 9.88889 7.93748 9.88889 8.12622 9.79201C8.29225 9.70679 8.42723 9.5708 8.51182 9.40355C8.60799 9.2134 8.60799 8.96449 8.60799 8.46667V2.42222C8.60799 1.9244 8.60799 1.67549 8.51182 1.48534C8.42723 1.31809 8.29225 1.1821 8.12622 1.09688C7.93748 1 7.69041 1 7.19625 1H2.07872C1.58457 1 1.3375 1 1.14875 1.09688C0.982733 1.1821 0.847753 1.31809 0.763161 1.48534C0.666992 1.67549 0.666992 1.9244 0.666992 2.42222V9.88889ZM8.60799 2.77778H14.2549C14.7491 2.77778 14.9961 2.77778 15.1849 2.87466C15.3509 2.95988 15.4859 3.09586 15.5705 3.26312C15.6666 3.45326 15.6666 3.70218 15.6666 4.2V10.2444C15.6666 10.7423 15.6666 10.9912 15.5705 11.1813C15.4859 11.3486 15.3509 11.4846 15.1849 11.5698C14.9961 11.6667 14.7491 11.6667 14.2549 11.6667H10.0197C9.52557 11.6667 9.27849 11.6667 9.08975 11.5698C8.92373 11.4846 8.78875 11.3486 8.70415 11.1813C8.60799 10.9912 8.60799 10.7423 8.60799 10.2444V2.77778Z",
    stroke: "#F5F5F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.666992 8.29062C0.666992 8.85068 0.666992 9.1307 0.775986 9.34462C0.871859 9.53278 1.02484 9.68576 1.213 9.78163C1.42691 9.89062 1.70694 9.89062 2.26699 9.89062H5.07866V5.44618H0.666992V8.29062Z",
    stroke: "#F5F5F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60645 8.29062C8.60645 8.85068 8.60645 9.1307 8.49745 9.34462C8.40158 9.53278 8.2486 9.68576 8.06044 9.78163C7.84652 9.89062 7.5665 9.89062 7.00645 9.89062H5.07711V5.44618H8.60645V8.29062Z",
    stroke: "#F5F5F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60645 2.6C8.60645 2.03995 8.60645 1.75992 8.49745 1.54601C8.40158 1.35785 8.2486 1.20487 8.06044 1.10899C7.84652 1 7.5665 1 7.00645 1H5.07711V5.44444H8.60645V2.6Z",
    stroke: "#F5F5F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.667 10.0719C15.667 10.6319 15.667 10.912 15.558 11.1259C15.4621 11.314 15.3091 11.467 15.121 11.5629C14.9071 11.6719 14.627 11.6719 14.067 11.6719H12.1377V7.22743H15.667V10.0719Z",
    stroke: "#F5F5F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.667 4.38125C15.667 3.8212 15.667 3.54117 15.558 3.32726C15.4621 3.1391 15.3091 2.98612 15.121 2.89024C14.9071 2.78125 14.627 2.78125 14.067 2.78125H12.1377V7.22569H15.667V4.38125Z",
    stroke: "#F5F5F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1367 2.78125H8.60739V7.22569H12.1367V2.78125Z",
    stroke: "#F5F5F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalTime);
export default __webpack_public_path__ + "static/media/goalTime.dd1cbe50d5cf4f0493ee172da909e299.svg";
export { ForwardRef as ReactComponent };